import {
  SmsTemplateCreateRequestDTO,
  SmsTemplateDeleteRequestDTO,
  SmsTemplateDTO,
  SmsTemplateReadByIdRequestDTO,
  SmsTemplateUpdateRequestDTO,
} from "./sms-template.interface";
import { Component, ElementRef, inject, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { UserLoginService } from "src/app/Common/UserLoginService/userlogin.service";
import { SmsTemplateService } from "./sms-template.service";
import { formatDateForInput } from "src/app/Shared/customFunctions/CustomFunctions";
import { ConfirmmodalserviceService } from "src/app/Shared/confirm-delete-modal/confirmmodalservice.service";
import { environment } from "src/environments/environment";
import { smsTemplateReadAllPaginatedRequestDTO } from "./sms-template.interface";

@Component({
  selector: "app-sms-template",
  templateUrl: "./sms-template.component.html",
  styleUrls: ["./sms-template.component.css"],
})
export class SmsTemplateComponent {
    totalCount: number = 0;
  //Flags
  isLoading: boolean = false;
  isSubmitting: boolean = false;

  //Services
  User = inject(UserLoginService).User();
  private SmsTemplateService = inject(SmsTemplateService);
  modalService = inject(NgbModal);
  private confirmModal = inject(ConfirmmodalserviceService)

  //Items
  smsTemplateList: SmsTemplateDTO[] = [];
  @ViewChild("smsTemplateModalForm", { static: false })
  smsTemplateModalContent!: ElementRef;
  addsmsTemplateModalContent!: NgbModalRef;

  //form

  smsTemplateForm = new FormGroup({
    tName: new FormControl("", [Validators.required]),
    tDesc: new FormControl(""),
    templateData: new FormControl("", [Validators.required]),
    templateVariable: new FormControl("", [Validators.required]),
    templateCreatedDate: new FormControl(""),
    templateApprovedDate: new FormControl(""),
    otherDetail1: new FormControl(""),
    otherDetail2: new FormControl(""),
    otherDetail3: new FormControl(""),
    otherDetail4: new FormControl(""),
    otherDetail5: new FormControl(""),
    otherDetail6: new FormControl(""),
    templateId: new FormControl(0),
  });
  PaginatedDTO: smsTemplateReadAllPaginatedRequestDTO = {
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    pageNo: 1,
    pageSize: 10,
    whereClause: "",
    orderByClause: ""
  }
  ngOnInit() {
    this.getSmsTemplateList(this.PaginatedDTO);
  }

  openSmsTemplateForm() {
    this.smsTemplateForm.reset();
    this.addsmsTemplateModalContent = this.modalService.open(
      this.smsTemplateModalContent
    );
  }

  submitSmsTemplateForm() {
    this.smsTemplateForm.markAllAsTouched();
    if (this.smsTemplateForm.valid) {
      this.isSubmitting = true;
      const formData = { ...this.smsTemplateForm.value };
      let data: SmsTemplateUpdateRequestDTO = {
        templateId: formData.templateId ?? 0,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        tName: formData.tName ?? "",
        tDesc: formData.tDesc ?? "",
        templateData: formData.templateData ?? "",
        templateVariable: formData.templateVariable ?? "",
        templateCreatedDate: new Date(formData.templateCreatedDate!),
        templateApprovedDate: new Date(formData.templateApprovedDate!),
        otherDetail1: formData.otherDetail1 ?? "",
        otherDetail2: formData.otherDetail2 ?? "",
        otherDetail3: formData.otherDetail3 ?? "",
        otherDetail4: formData.otherDetail4 ?? "",
        otherDetail5: formData.otherDetail5 ?? "",
        otherDetail6: formData.otherDetail6 ?? "",
        isActive: 1,
        actionUser: String(this.User.userId),
      };

      if (formData.templateId && formData.templateId !== 0) {
        this.updateSmsTemplateList(data);
      } else {
        this.createSmsTemplateList(data);
      }
    }
  }

  getSmsTemplateList(data: smsTemplateReadAllPaginatedRequestDTO) {
    this.isLoading = true;
    this.SmsTemplateService.ReadAllPaginatedsmsTemplate(data).subscribe({
      next: (res) => {
        this.smsTemplateList = res.items;
     
        this.isLoading = false;
        console.log('Pagination response:', res);
      },
      error: (err) => {
        console.error("Error fetching config list:", err);
        this.isLoading = false;
      },
    });
  }
  handlePageSizeChange(event: { currentPage: number; pageSize: number }) {
    this.PaginatedDTO.pageNo = event.currentPage ?? 1;
    this.PaginatedDTO.pageSize = event.pageSize ?? 10;
    this.getSmsTemplateList(this.PaginatedDTO);
  }

  handleActionClick(event: { actionName: string; rowData: SmsTemplateDTO }) {
    if (event.actionName === "Edit") {
      this.smsTemplateForm.patchValue({
        templateId: event.rowData.templateId,
        tName: event.rowData.tName,
        tDesc: event.rowData.tDesc,
        templateVariable: event.rowData.templateVariable,
        templateData: event.rowData.templateData,
        templateApprovedDate: formatDateForInput(
          event.rowData.templateApprovedDate
        ),
        templateCreatedDate: formatDateForInput(
          event.rowData.templateCreatedDate
        ),
        otherDetail1: event.rowData.otherDetail1,
        otherDetail2: event.rowData.otherDetail2,
        otherDetail3: event.rowData.otherDetail3,
        otherDetail4: event.rowData.otherDetail4,
        otherDetail5: event.rowData.otherDetail5,
        otherDetail6: event.rowData.otherDetail6,
      });
      this.addsmsTemplateModalContent = this.modalService.open(
        this.smsTemplateModalContent
      );
    }

    if (event.actionName === "Delete") {
      this.confirmModal
        .openDeleteModal(event.rowData.tName!, event.rowData)
        .subscribe((res) => {
          if (res) {
            const data: SmsTemplateDeleteRequestDTO = {
              templateId: event.rowData.templateId,
              tenantId: event.rowData.tenantId ?? this.User.companyId,
              tenantBranchId: event.rowData.tenantBranchId ?? this.User.loggedInBranchId,
              actionUser: String(this.User.userId)
            };

            this.deleteSmsTemplateList(data);
          }
        });
    }
  }

  createSmsTemplateList(data: SmsTemplateCreateRequestDTO) {
    this.SmsTemplateService.SmsTemplate_Create(data).subscribe({
      next: (res) => {
        this.addsmsTemplateModalContent.close();
        this.getSmsTemplateList(this.PaginatedDTO);
        this.isSubmitting = false;
      },
      error: (err)=> {
        this.isSubmitting = false;
      }
    });
  }
  updateSmsTemplateList(data: SmsTemplateUpdateRequestDTO) {
    this.SmsTemplateService.SmsTemplate_Update(data).subscribe({
      next: (res) => {
        this.addsmsTemplateModalContent.close();
        this.getSmsTemplateList(this.PaginatedDTO);
        this.isSubmitting = false;
      },
      error: (err)=> {
        this.isSubmitting = false;
      }
    });
  }
  deleteSmsTemplateList(data: SmsTemplateDeleteRequestDTO) {
    this.SmsTemplateService.SmsTemplate_Delete(data).subscribe({
      next: (res) => {
        this.getSmsTemplateList(this.PaginatedDTO);
      },
    });
  }
}
